function PensionHelper(secondPillar) {
  const self = this
  self.secondPillar = secondPillar


  self.redirectIfSuspendOrExitIsCancelable = function () {
    if (self.secondPillar.isExitedOrSuspended()) {
      if (session.pension.secondPillar.isExitCancelable || session.pension.secondPillar.isSuspendCancelable) {
        location.href = '#myoptions'
      }
    }
  }

  self.redirectIfNotSuspendOrExitIsCancelable = function () {
    if (!self.secondPillar.isExitedOrSuspended()) {
      location.href = '#overview'
    }

    if (!session.pension.secondPillar.isExitCancelable && !session.pension.secondPillar.isSuspendCancelable) {
      location.href = '#overview'
    }
  }

  this.getSuspendCancellationMaxDate = function () {
    let lastSuspendCancelDate = new Date(self.secondPillar.lastSuspendCancelDate)

    if (lastSuspendCancelDate) {
      let month = lastSuspendCancelDate.getMonth() + 1
      return lastSuspendCancelDate.getDate() + '.' + (month < 10 ? "0" + month : month) + '.' + lastSuspendCancelDate.getFullYear()
    }
    else
      return ""
  }

  this.getExitCancellationMaxDate = function () {
    let lastExitCancelDate = new Date(self.secondPillar.lastExitCancelDate)

    if (lastExitCancelDate) {
      let month = lastExitCancelDate.getMonth() + 1
      return lastExitCancelDate.getDate() + '.' + (month < 10 ? "0" + month : month) + '.' + lastExitCancelDate.getFullYear()
    }
    else
      return ""
  }
}